/* Theme Enhancements JS — smooth, progressive enhancements.
   Non-destructive: only adds behaviors, never removes existing ones. */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // 1) Lazy image fade-in
  function fadeImages() {
    var imgs = document.querySelectorAll('img[loading="lazy"]');
    imgs.forEach(function (img) {
      if (img.classList.contains('te-fade')) return;
      img.classList.add('te-fade');
      if (img.complete && img.naturalWidth > 0) {
        img.classList.add('te-loaded');
      } else {
        img.addEventListener('load', function () { img.classList.add('te-loaded'); }, { once: true });
        img.addEventListener('error', function () { img.classList.add('te-loaded'); }, { once: true });
      }
    });
  }

  // 2) Reveal-on-scroll for sections that don't already use the theme's built-in reveal
  function revealOnScroll() {
    if (reduceMotion || !('IntersectionObserver' in window)) return;
    var candidates = document.querySelectorAll(
      '.shopify-section:not(.shopify-section-header):not(.shopify-section-footer) > *:not(.te-reveal)'
    );
    var targets = [];
    candidates.forEach(function (el) {
      if (el.classList.contains('scroll-trigger')) return; // theme already animates it
      if (el.getBoundingClientRect().top < window.innerHeight * 0.9) return; // already in view
      el.classList.add('te-reveal');
      targets.push(el);
    });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-visible');
          io.unobserve(e.target);
        }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.05 });
    targets.forEach(function (t) { io.observe(t); });
  }

  // 3) Back-to-top button
  function backToTop() {
    if (document.querySelector('.te-to-top')) return;
    var btn = document.createElement('button');
    btn.className = 'te-to-top';
    btn.setAttribute('aria-label', 'Scroll to top');
    btn.type = 'button';
    btn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="18 15 12 9 6 15"></polyline></svg>';
    btn.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: reduceMotion ? 'auto' : 'smooth' });
    });
    document.body.appendChild(btn);
    var ticking = false;
    function update() {
      ticking = false;
      if (window.scrollY > 600) btn.classList.add('is-visible');
      else btn.classList.remove('is-visible');
    }
    window.addEventListener('scroll', function () {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    }, { passive: true });
  }

  // 4) Header shadow on scroll (stacks with theme sticky behavior)
  function headerOnScroll() {
    var header = document.querySelector('.header-wrapper');
    if (!header) return;
    var ticking = false;
    function update() {
      ticking = false;
      if (window.scrollY > 8) header.classList.add('te-scrolled');
      else header.classList.remove('te-scrolled');
    }
    update();
    window.addEventListener('scroll', function () {
      if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
  }

  // 5) Smooth anchor jumps
  function smoothAnchors() {
    if (reduceMotion) return;
    document.addEventListener('click', function (ev) {
      var a = ev.target.closest && ev.target.closest('a[href^="#"]');
      if (!a) return;
      var id = a.getAttribute('href');
      if (!id || id === '#' || id.length < 2) return;
      var tgt = document.querySelector(id);
      if (!tgt) return;
      ev.preventDefault();
      tgt.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  // 6) Re-run after Shopify section reloads (theme editor)
  function bindShopifyEvents() {
    if (!window.Shopify) return;
    document.addEventListener('shopify:section:load', function () {
      fadeImages();
      revealOnScroll();
    });
  }

  function init() {
    fadeImages();
    revealOnScroll();
    backToTop();
    headerOnScroll();
    smoothAnchors();
    bindShopifyEvents();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
